module.exports = __webpack_public_path__ + "static/media/logo-provisoria2.85baad61.svg";